














import { Component, Prop, Vue } from 'vue-property-decorator'
import RegisterForm from './../inner/RegisterForm.vue'
import Privacy from './../inner/Privacy.vue'
import Terms from './../inner/Terms.vue'
import AboutUs from './../inner/AboutUs.vue'
@Component({
  components: {
    RegisterForm,
    Privacy,
    Terms,
    AboutUs
  }
})
export default class Modals extends Vue {
}
